export const LOCATION_CHANGE = "@@router/LOCATION_CHANGE";
export const CHANGE_GO_BACK_LABEL = "@@router/CHANGE_GO_BACK_LABEL";
export const SHOW_GO_BACK = "@@router/SHOW_GO_BACK";


export const getPreviousPathname = state => state.router.previousPathname;
export const isShownGoBack = state => state.router.isShownGoBack;
export const getGoBackLabel = state => state.router.goBackLabel;

export function showGoBack(isShown) {
  return dispatch => dispatch({
    type: SHOW_GO_BACK,
    isShown
  });
}

export function changeGoBackLabel(label) {
  return dispatch => dispatch({
    type: CHANGE_GO_BACK_LABEL,
    label
  });
}


const initialState = {
  location: null,
  action: null,
  visitedRouts: [],
  isShownGoBack: false,
  goBackLabel: ""
};

/**
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state is discouraged.
 */
export function routerReducer(state = initialState, { type, payload } = {}) {
  switch (type) {
    case LOCATION_CHANGE:
      const currentLine = state.visitedRouts.length < 3
        ? state.visitedRouts.concat(payload.location.pathname)
        : state.visitedRouts.slice(-2).concat(payload.location.pathname);
      const currentLineLen = currentLine.length;

      return {
        ...state,
        location: payload.location,
        visitedRouts: currentLine,
        previousPathname: currentLine[currentLineLen - 2]

      };
    case CHANGE_GO_BACK_LABEL:
      return {
        ...state,
        goBackLabel: payload.label
      };
    case SHOW_GO_BACK:
      return {
        ...state,
        isShownGoBack: payload.isShown
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/ducks/router/routerReducer.js